/**
 * The order cannot be shipped from here any more: its shipment was recorded
 * but Shopify did not confirm it, it already has one, or it is no longer
 * received. Unlike a refusal of what was packed, nothing in the dialog can fix
 * it, so sending again is not the way out.
 */
export class OrderNotShippableError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "OrderNotShippableError";
  }
}

/**
 * No answer came for the shipment (a timeout, here or at the gateway, or a
 * dropped connection), so it may well have gone. Sending it again could ship
 * it twice; the list says how it really stands.
 */
export class ShipmentUnconfirmedError extends Error {
  constructor(options?: { cause?: unknown }) {
    super("Não foi possível confirmar o envio.", options);
    this.name = "ShipmentUnconfirmedError";
  }
}
